import React from 'react';
import { useParams } from 'react-router-dom';
import ImageGallery from 'react-image-gallery';
import './assets/profile.scss'
import Header from '../../components/Header'
import StoryImage from '../../components/StoryImage'
import Chip from '@mui/material/Chip';
import { MdWhatsapp, MdCall } from 'react-icons/md';
import { LinearProgress } from '@mui/material';

const Application = () => {
  const getChanel = (ch) => {
    switch (ch) {
      case 'whatsapp':
        return <div className='whatsapp'><a href={`https://wa.me/${item.phone}`}><MdWhatsapp /></a></div>
      case 'direct':
        return <div className='direct'><a href={`tel:${item.phone}`}><MdCall /></a></div>
      default:
        return false
    }
  }
  let params = useParams();
  const [item, setItem] = React.useState({})
  const fetchData = () => {
    fetch(`https://usemta3gdj.execute-api.eu-central-1.amazonaws.com/prod/announcements/${params.userId}`)
      .then(response => response.json())
      .then(data => setItem(data))
      .then(data => console.log(data))
      .catch(error => console.log(`********* ${error}`))
  }

  React.useEffect(() => {
    fetchData()
  }, [])

  return (
    <div className='profile-content'>
      <Header back={true} />
      
    </div>
  );
}


export default Application;